import { emailRegx, httpsWwwRegex, nameRegex, passowrdRegx } from "./regex";

export const Validator = {
  name(data) {
    if (data.trim().match(nameRegex)) {
      return true;
    } else {
      return false;
    }
  },
  text(data, l = 0) {
    if (
      data !== null &&
      data !== "" &&
      data !== undefined &&
      data.trim() !== "" &&
      data.length > l
    ) {
      return true;
    }
    return false;
  },
  number(data, min, max) {
    if (!isNaN(data) && typeof data === "number") {
      if (
        (min === undefined || data >= min) &&
        (max === undefined || data <= max)
      ) {
        return true;
      }
    }
    return false;
  },
  rangeComparison(start, end) {
    const startNum = Number(start);
    const endNum = Number(end);
    if (!isNaN(startNum) && !isNaN(endNum) && startNum <= endNum) {
      return true;
    }
    return false;
  },
  email(data) {
    if (data?.length > 0) {
      if (data.match(emailRegx)) {
        return true;
      }
    }
    return false;
  },
  password(data) {
    if (data.length > 0) {
      if (passowrdRegx.test(data)) {
        return true;
      }
    }
    return false;
  },
  confirmPasswordCheck(password, confirmPassword) {
    if (password === confirmPassword) {
      return true;
    } else {
      return false;
    }
  },
  hasMultiple(data) {
    if (Array.isArray(data) && data.length > 0) {
      return true;
    }
    return false;
  },
  isHttpsWwwUrl(data) {
    return httpsWwwRegex.test(data);
  },
};
